<div class="overlay" *ngIf="type == 'performanceMetrics'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain Failure Metrics</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="performanceMetricsForm" (ngSubmit)="submitPerformanceMetricsForm()">
        <div class="form-group mx-2 my-3">
          <label for="availability"> Asset Availablity </label>
          <input id="availability" type="number" formControlName="availability" max="100" min="0"
            class="form-control" />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Asset Performance </label>
          <input id="performance" type="number" formControlName="performance" max="100" min="0" class="form-control" />
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button mat-raised-button color="primary">Update</button>
          <button mat-stroked-button color="warn" (click)="closeModal()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!---------------------------------------------------------- YTD METRICS FORM STARTS --------------------------------------------------------->
<div class="overlay" *ngIf="type == 'ytdMetrics'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain YTD Metrics</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="YTDMetricsForm" (ngSubmit)="submitYTDMetricsForm()">
        <div class="form-group mx-2 my-3">
          <label for="unexpected_failures"> YTD Unexpected Failures*:</label>
          <input type="number" formControlName="unexpected_failures" min="0" id="unexpected_failures"
            class="form-control" />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="failures_cost"> YTD TOTAL Failure Cost*: </label>
          <input type="number" formControlName="failures_cost" min="0" id="failures_cost" class="form-control" />
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button type="submit" mat-raised-button color="primary">
            Update
          </button>
          <button mat-stroked-button color="warn" (click)="closeModal()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!---------------------------------------------------------- YTD METRICS FORM ENDS --------------------------------------------------------->

<div class="overlay" *ngIf="type == 'falseClaimsMetrics'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain False Claims Metrics</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="flaseClaimsMetricsForm" (ngSubmit)="submitFalseClaimsMetricsForm()">
        <div class="form-group mx-2 my-3">
          <label for="positives"> False Positives*:</label>
          <input type="number" formControlName="positives" min="0" id="positives" class="form-control" />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="negatives"> False Negatives*: </label>
          <input type="number" formControlName="negatives" min="0" id="negatives" class="form-control" />
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button type="submit" mat-raised-button color="primary">
            Update
          </button>
          <button mat-stroked-button color="warn" (click)="closeModal()" type="button">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!---------------------------------------------------------- FALSE CLAIMS METRICS FORM ENDS --------------------------------------------------------->
<!---------------------------------------------------------- MOTOR TYPE FORM STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'motor_selection'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Sensor Details</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="motorTypeForm" (ngSubmit)="selectMotorType()">
        <input type="radio" name="motor_type" value="INDUCTION_MOTOR" formControlName="type" />
        Induction Motor
        <input type="radio" name="motor_type" value="SYNCHRONOUS_MOTOR" formControlName="type" />
        Synchronous Motor
        <input type="radio" name="motor_type" value="DC_MOTOR" formControlName="type" />
        DC Motor
        <input type="radio" name="motor_type" value="ALTERNATOR" formControlName="type" />
        Alternator
        <div class="powertrain-modal-footer flex_center_end">
          <button type="submit" mat-raised-button color="primary">
            Select
          </button>
          <button mat-stroked-button color="warn" (click)="closeModal()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!---------------------------------------------------------- MOTOR TYPE FORM ENDS  ------------------------------------------------------------------>
<!---------------------------------------------------------- SENSOR TYPEFORM STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'asset_selection'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Sensor Details</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="sensorTypeForm" (ngSubmit)="selectPowertrainSensorType()" class="powertrain-modal-form">
        <div class="m_1">
          <label for="type">Asset Type*</label>
          <select class="form-control" formControlName="assetType">
            <option value="MOTOR">Motor</option>
            <option value="GEAR">Gear</option>
            <option value="PUMP">Pump</option>
            <option value="FAN_BLOWER">Fan/Blower</option>
            <option value="COMPRESSOR">Compressor</option>
            <option value="JOURNAL_BEARING">Journal Bearing</option>
          </select>
        </div>
        <div class="m_1" *ngIf="assetTypeValue === 'MOTOR'">
          <label for="type">Motor Type*</label>
          <select class="form-control" formControlName="subType">
            <option value="SYNCHRONOUS_MOTOR">Synchronous Motor</option>
            <option value="INDUCTION_MOTOR">Induction Motor</option>
            <option value="DC_MOTOR">DC Motor</option>
            <option value="ALTERNATOR">Alternator</option>
          </select>
        </div>
        <div class="m_1">
          <label for="sensorMarker"> Sensor Name* </label>
          <input type="text" id="sensorMarker" formControlName="sensorMarker" class="form-control" />
        </div>
        <div class="m_1">
          <label for="sensorMarker"> Sensor Display Name* </label>
          <input type="text" id="sensorMarker" formControlName="sensorDNames" class="form-control" />
          <small id="powertrain-name" class="form-text text-muted">Max 9 characters.</small>
        </div>
        <div class="m_1 d-flex justify-content-start align-items-center">
          <div class="d-flex justify-content-center align-items-center">
            <input type="radio" name="motor_type" value="MASTER" disabled formControlName="assetMarker" id="master" />
            <label for="master" class="mx-2">Master</label>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <input type="radio" name="motor_type" value="CHILD" disabled formControlName="assetMarker" id="child" />
            <label for="child" class="mx-2">Child</label>
          </div>
        </div>

        <div class="powertrain-modal-footer flex_center_end">
          <button type="submit" [disabled]="sensorTypeForm.invalid" mat-raised-button color="primary">
            Select
          </button>
          <button type="button" mat-stroked-button color="warn" (click)="closeModal()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!---------------------------------------------------------- SENSOR TYPEFORM ENDS  ------------------------------------------------------------------>

<!----------------------------------------------------------POWERTRAIN NAME STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'powertrain_name'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain Name</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="powertrainNameForm" (ngSubmit)="inputpowertrainForm()">
        <div class="form-group m-4">
          <label for="powertrain-name">Powertrain Name</label>
          <input type="text" class="form-control" formControlName="powertrain_name" id="powertrain-name"
            aria-describedby="powertrain-name" />
          <small id="powertrain-name" class="form-text text-muted">Min 5 characters.</small>
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button type="submit" class="btn primary_btn" [disabled]="powertrainNameForm.invalid">
            Confirm
          </button>
          <button mat-stroked-button color="warn" type="button" (click)="closeModal()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!----------------------------------------------------------POWERTRAIN NAME ENDS ----------------------------------------------------------------->
<!----------------------------------------------------------POWERTRAIN DELETE STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'delete_powertrain'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Delete Powertrain</div>
    </div>
    <div class="powertrain-modal-body">
      <div class="form-group m-4">
        <div id="powertrain-name" class="form-text text-muted">
          Are you sure you want to permanently remove this powertrain?
        </div>
      </div>
      <div class="powertrain-modal-footer flex_center_end">
        <button type="submit" mat-raised-button color="primary" (click)="closePowertrainDeleteModal(true)">
          Confirm
        </button>
        <button type="button" mat-stroked-button color="warn" (click)="closePowertrainDeleteModal(false)">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

<!----------------------------------------------------------POWERTRAIN DELETE ENDS ----------------------------------------------------------------->
<!----------------------------------------------------------POWERTRAIN PLATE DETAILS STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'plate_details'">
  <div class="powertrain-modal" [ngStyle]="{ width: '60vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain Details</div>
    </div>
    <div class="powertrain-modal-body">
      <div class="sensor_headers">
        <div class="flex_10 p-2 border font-weight-bold">Sensor</div>
        <div class="flex_20 p-2 border font-weight-bold">Marker</div>
        <div class="flex_30 p-2 border font-weight-bold">Mac Address</div>
        <div class="flex_30 p-2 border font-weight-bold">Serial Number</div>
        <div class="flex_10 p-2 border font-weight-bold"></div>
      </div>
      <div class="sensor_headers" *ngFor="let s of sensors">
        <div class="flex_10 p-2 border">{{ s.assetType }}</div>
        <div class="flex_20 p-2 border">{{ s.sensorMarker }}</div>
        <div class="flex_30 p-2 border">{{ s.mac_address }}</div>
        <div class="flex_30 p-2 border">{{ s.motor_serial }}</div>
        <div class="flex_10 p-2 border">
          <!-- <button (click)="editSensor(s)">Edit</button> -->
          <div class="">
            <button mat-raised-button color="primary" (click)="editSensor(s)">
              Edit
            </button>
          </div>
        </div>
      </div>
      <div class="powertrain-modal-footer flex_center_end">
        <button type="button" mat-stroked-button color="warn" (click)="closePlateDetailsModalBox()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!----------------------------------------------------------POWERTRAIN PLATE DETAILS ENDS ----------------------------------------------------------------->
<!----------------------------------------------------------POWERTRAIN PLATE DETAILS  SENSOR EDIT STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="isEditingSensor">
  <div class="powertrain-modal" [ngStyle]="{ width: '27vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Edit Sensor</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="sensorNameForm" (ngSubmit)="saveSensorName()">
        <div class="form-row">
          <div class="form-group m-4">
            <label for="">Sensor Display Name</label>
            <input type="text" class="form-control" formControlName="sensorDNames" />
          </div>
          <div class="form-group m-4">
            <label for="">Sensor Name</label>
            <input type="text" class="form-control" formControlName="sensorMarker" />
          </div>
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button type="button" mat-stroked-button color="warn" (click)="closeSensorNameModalBox()">
            Close
          </button>
          <button mat-raised-button color="primary" [disabled]="sensorNameForm.invalid">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!----------------------------------------------------------POWERTRAIN PLATE DETAILS  SENSOR EDIT ENDS ----------------------------------------------------------------->

<!----------------------------------------------------------POWERTRAIN IMAGE MODAL STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'powertrain_image'" (click)="closePowertrainImgModalBox()">
  <!-- <div class="powertrain-modal" [ngStyle]="{ width: '40vw' }"> -->
  <div class="powertrain-modal" [ngStyle]="{ 'z-index': 1001, overflow: 'scroll', 'max-height': '100%' }"
    (click)="$event.stopPropagation()">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain Details</div>
    </div>
    <div class="powertrain-modal-body">
      <div class="border_wrapper" style="height: 100%; position: relative">
        <div class="powertrain_name">
          {{ powertrainName }}
        </div>
        <div class="center_flex">
          <!-- width: '75%',
          height: '100%', -->
          <div class="cursor-move" [ngStyle]="{ position: 'relative' }">
            <!-- Place .img here for the image -->
            <img [src]="powertrainImg" class="w-100 h-100 img" />

            <!-- Sensors -->
            <!-- class="sensor rounded-lg center_flex" -->
            <div class="new_sensor_style rounded-lg" [matTooltip]="showTooltip(sensor)" [matTooltipClass]="'tooltip'"
              *ngFor="let sensor of sensors" [ngStyle]="{
                top: sensor.yPercentage + '%',
                left: sensor.xPercentage + '%',
                position: 'absolute',
                'background-color': sensor.color
              }" (click)="onSensorClick(sensor)">
              <!-- [ngClass]="{
                'pulsing-circle': sensor.color == '#ff2a1b',
                border_yellow: sensor.color == '#faa700',
                border_green: sensor.color == '#72ff13'
              }" -->
              <!-- <div class="sensor_no"> -->
              <div class="sensor_no">
                <!-- {{ sensor.sensor_number == 0 ? "B" : sensor.sensor_number }} -->
                <!-- {{ sensor.sensorMarker }} -->
                {{ sensor.sensorDNames }}
              </div>
              <img src="./assets/wifion.png" width="16" height="16" alt=""
                *ngIf="sensor.asset_status == 1 || sensor.asset_status == 0" />
              <img src="./assets/wifioff.png" width="16" height="16" alt="" *ngIf="sensor.asset_status == 2" />
            </div>
          </div>
        </div>
        <div class="powertrain_edit_icon" (click)="editPowertrain()">
          <mat-icon>edit</mat-icon>
        </div>
        <div class="powertrain_close_icon" (click)="closePowertrainImgModalBox()">
          <mat-icon>close</mat-icon>
        </div>
      </div>
      <div class="powertrain-modal-footer flex_center_end">
        <button type="button" mat-stroked-button color="warn" (click)="closePowertrainImgModalBox()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!----------------------------------------------------------POWERTRAIN IMAGE MODAL STARTS ENDS ----------------------------------------------------------------->

<!----------------------------------------------------------POWERTRAIN PHYSICAL IMAGES MODAL STARTS ENDS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'img_modal'">
  <div class="powertrain-modal" [ngStyle]="{ width: '40vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">On-Site Powertrain Images</div>
    </div>
    <div class="powertrain-modal-body">
      <button *ngIf="imgSrc == ''" type="button" class="btn default_btn" (click)="goToImageLink(imrSrc)">
        Add Image
      </button>
      <!-- <button
        *ngIf="imgSrc != ''"
        type="button"
        class="btn default_btn"
        (click)="goToImageLink(imrSrc)"
      >
        Update Image
      </button> -->
      <input type="file" name="myfile" class="m-4" ng2FileSelect [uploader]="uploader"
        (change)="upload($event.target.files, 'companyLogo')" />
      <div class="w-100 d-flex align-items-center justify-content-center" *ngIf="this.uploadLoader">
        <div class="spinner-container charts-loader">
          <div class="spinner-border text-primary"></div>
        </div>
      </div>
      <div class="powertrain-modal-footer flex_center_end">
        <button type="button" mat-stroked-button color="warn" (click)="closePTPhysicalimageModalBox()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!----------------------------------------------------------POWERTRAIN POWERTRAIN PHYSICAL IMAGES  MODAL STARTS ENDS ----------------------------------------------------------------->

<!----------------------------------------------------------POWERTRAIN PHYSICAL IMAGES MODAL SHOW STARTS ENDS -------------------------------------------------------->
<div class="overlay" *ngIf="type == 'powertrain_phy_image'">
  <div class="powertrain-modal">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain Image</div>
    </div>
    <div class="powertrain-modal-body">
      <img [src]="data.url" [alt]="data.url" class="pt-phy-img" />
    </div>
    <div class="powertrain-modal-footer flex_center_end">
      <button type="button" mat-stroked-button color="primary" (click)="closePTPhysicalimageModalBox()">
        Close
      </button>
      <button type="button" class="btn default_btn" mat-stroked-button color="warn"
        (click)="deletePTPhysicalimageModalBox()">
        Delete
      </button>
    </div>
  </div>
</div>
<!----------------------------------------------------------POWERTRAIN POWERTRAIN PHYSICAL IMAGES SHOW  MODAL STARTS ENDS ------------------------------------------->
<!----------------------------------------------------------POWERTRAIN COMMISSION DATE MODAL STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'commissionDate'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Select your choice</div>
    </div>
    <div class="powertrain-modal-body">
      <div class="input-group mb-3">
        <label class="form-label" id="basic-addon1">Start Date</label>
        <input type="date" class="form-control" placeholder="Date" aria-label="Date" aria-describedby="basic-addon1"
          [(ngModel)]="commission_date" />
      </div>
    </div>
    <div class="powertrain-modal-footer flex_center_end">
      <button type="button" mat-raised-button color="primary" (click)="saveCommissionDate()">
        Save
      </button>
      <button type="button" mat-stroked-button color="warn" (click)="closeCommissionModal()">
        Close
      </button>

    </div>
  </div>
</div>
<!----------------------------------------------------------POWERTRAIN COMMISSION DATE MODAL ENDS ----------------------------------------------------------------->
<!----------------------------------------------------------POWERTRAIN OFS DATE MODAL STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'out_of_service_pt'">
  <div class="powertrain-modal" [ngStyle]="{ width: '30vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Confirm your choice</div>
    </div>
    <div class="powertrain-modal-body">
      <div class="input-group mb-3 p-4 d-flex align-items-center justify-content-center">
        Are you sure you want to proceed with your selection ?
      </div>
    </div>
    <div class="powertrain-modal-footer flex_center_end">
      <button type="button" color="primary" mat-raised-button color="primary" (click)="saveOutForServiceData()">
        Update
      </button>
      <button type="button" mat-stroked-button color="warn" (click)="closeOFSModal()">
        Close
      </button>

    </div>
  </div>
</div>
<!----------------------------------------------------------POWERTRAIN OFS DATE MODAL ENDS ----------------------------------------------------------------->


<!----------------------------------------------------------POWERTRAIN YTD V2 MODAL STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'ytdMetricsV2'">
  <div class="powertrain-modal" [ngStyle]="{ width: '40vw', maxWidth: '500px' }">
    <!-- Header with improved styling -->
    <div class="powertrain-modal-header" style="background-color: #3f51b5; color: white; padding: 16px 24px;">
      <div class="powertrain-modal-title" style="font-size: 18px; font-weight: 500;">Powertrain YTD Metrics</div>
    </div>

    <!-- Body with better spacing -->
    <div class="powertrain-modal-body" style="padding: 16px;">
      <form [formGroup]="YTDMetricsFormV2" (ngSubmit)="submitYTDMetrics()">
        <!-- Cost input with improved styling -->
        <div class="form-group mx-2 my-3">
          <label for="cost" style="display: block; margin-bottom: 8px; font-weight: 500;">Cost of failure/hr*</label>
          <input id="cost" type="number" formControlName="cost" max="100" min="0" class="form-control"
            placeholder="Enter cost per hour"
            style="width: 100%; padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px;" />
        </div>

        <!-- Start date with calendar icon -->
        <div class="form-group mx-2 my-3">
          <label for="start_date" style="display: block; margin-bottom: 8px; font-weight: 500;">Failed at*</label>
          <div style="position: relative;">
            <input id="start_date" type="datetime-local" formControlName="start_date" class="form-control"
              style="width: 100%; padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px;" />
          </div>
          <div
            *ngIf="YTDMetricsFormV2.get('start_date')?.errors?.['startDateInvalid'] && YTDMetricsFormV2.get('start_date')?.touched"
            class="error-text">
            Start date must be before end date
          </div>
        </div>

        <!-- End date with calendar icon -->
        <div class="form-group mx-2 my-3">
          <label for="end_date" style="display: block; margin-bottom: 8px; font-weight: 500;">Fixed at*</label>
          <div style="position: relative;">
            <input id="end_date" type="datetime-local" formControlName="end_date" class="form-control"
              style="width: 100%; padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px;" />
          </div>
          <div
            *ngIf="YTDMetricsFormV2.get('end_date')?.errors?.['endDateInvalid'] && YTDMetricsFormV2.get('end_date')?.touched"
            class="error-text">
            End date must be after start date
          </div>
        </div>

        <!-- Footer with improved button layout -->
        <div class="powertrain-modal-footer flex_center_end"
          style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px; padding: 16px 24px; background-color: #f8f9fa; border-top: 1px solid #dee2e6;">
          <button mat-raised-button color="primary" type="submit" [disabled]="YTDMetricsFormV2.invalid">Apply</button>
          <button mat-stroked-button color="warn" type="button" (click)="closeYTDModal()">
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!----------------------------------------------------------POWERTRAIN YTD V2 DATE MODAL ENDS ----------------------------------------------------------------->


<!---------------------------------------------------------- PIEZO SENSOR TYPEFORM STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'piezo_asset_selection'">
  <div class="powertrain-modal" [ngStyle]="{ width: '20vw' }">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Sensor Details</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="piezoSensorTypeForm" (ngSubmit)="selectPiezoPowertrainSensorType()" class="powertrain-modal-form">
        <div class="m_1">
          <label for="type">Master Type*</label>
          <select class="form-control" formControlName="master_type">
            <option value="1">Em Mini</option>
            <option value="2">Em Standard</option>
            <option value="3">Em Standard + RTDs</option>
            <option value="4">Piezo</option>
          </select>
        </div>
        <div class="m_1">
          <label for="type">Asset Type*</label>
          <select class="form-control" formControlName="assetType">
            <option value="MOTOR">Motor</option>
            <option value="GEAR">Gear</option>
            <option value="PUMP">Pump</option>
            <option value="FAN_BLOWER">Fan/Blower</option>
            <option value="COMPRESSOR">Compressor</option>
            <option value="JOURNAL_BEARING">Journal Bearing</option>
          </select>
        </div>
        <div class="m_1" *ngIf="assetTypeValue === 'MOTOR'">
          <label for="type">Motor Type*</label>
          <select class="form-control" formControlName="subType">
            <option value="SYNCHRONOUS_MOTOR">Synchronous Motor</option>
            <option value="INDUCTION_MOTOR">Induction Motor</option>
            <option value="DC_MOTOR">DC Motor</option>
            <option value="ALTERNATOR">Alternator</option>
          </select>
        </div>
        <div class="m_1">
          <label for="sensorMarker"> Sensor Name* </label>
          <input type="text" id="sensorMarker" formControlName="sensorMarker" class="form-control" />
        </div>
        <div class="m_1">
          <label for="sensorMarker"> Sensor Display Name* </label>
          <input type="text" id="sensorMarker" formControlName="sensorDNames" class="form-control" />
          <small id="powertrain-name" class="form-text text-muted">Max 9 characters.</small>
        </div>
        <div class="m_1 d-flex justify-content-start align-items-center">
          <div class="d-flex justify-content-center align-items-center">
            <input type="radio" name="motor_type" value="MASTER" disabled formControlName="assetMarker" id="master" />
            <label for="master" class="mx-2">Master</label>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <input type="radio" name="motor_type" value="CHILD" disabled formControlName="assetMarker" id="child" />
            <label for="child" class="mx-2">Child</label>
          </div>
        </div>

        <div class="powertrain-modal-footer flex_center_end">
          <button type="submit" [disabled]="piezoSensorTypeForm.invalid" mat-raised-button color="primary">
            Select
          </button>
          <button type="button" mat-stroked-button color="warn" (click)="closeModal()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!---------------------------------------------------------- PIEZO SENSOR TYPEFORM ENDS  ------------------------------------------------------------------>

<!---------------------------------------------------------- PIEZO POWERTRAIN IMAGE MODAL STARTS ----------------------------------------------------------------->
<div class="overlay" *ngIf="type == 'piezo_powertrain_image'" (click)="closePowertrainImgModalBox()">
  <div class="piezo_modal_container" (click)="$event.stopPropagation()">
    
    <!-- Header -->
    <div class="piezo_modal_header">
      <div class="piezo_modal_title">Powertrain Details</div>
      <div class="piezo_header_actions">
        <!-- <button mat-icon-button (click)="editPowertrain()" class="piezo_icon_btn" title="Edit">
          <mat-icon>edit</mat-icon>
        </button> -->
        <button mat-icon-button (click)="closePowertrainImgModalBox()" class="piezo_icon_btn" title="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="piezo_modal_body">
      <div class="piezo_content_wrapper">
        <div class="piezo_subsystem_name">
          {{ peizo_subsystem_data.subsystem_name }}
        </div>

        <div class="piezo_canvas_area">
          <div class="piezo_image_container">
            <img [src]="peizo_subsystem_data.Image_path" class="piezo_main_img" />

            <!-- Sensor Nodes -->
            <div 
              class="piezo_sensor_node" 
              *ngFor="let sensor of piezo_sensors"
              [matTooltip]="showTooltip(sensor)" 
              [matTooltipClass]="'tooltip'"
              [ngStyle]="{
                'top': sensor.yPercentage + '%',
                'left': sensor.xPercentage + '%',
                'background-color': sensor.color
              }" 
              (click)="onSensorClick(sensor)">
              
              <span class="piezo_sensor_label">{{ sensor.sensorDNames }}</span>
              
              <div class="piezo_status_icon">
                <img src="./assets/wifion.png" *ngIf="sensor.asset_status == 1 || sensor.asset_status == 0" />
                <img src="./assets/wifioff.png" *ngIf="sensor.asset_status == 2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="piezo_modal_footer">
      <button type="button" mat-stroked-button color="warn" (click)="closePowertrainImgModalBox()">
        Close
      </button>
    </div>
  </div>
</div>

<!----------------------------------------------------------PIEZO POWERTRAIN IMAGE MODAL STARTS ENDS ----------------------------------------------------------------->
<!----------------------------------------------------------PIEZO POWERTRAIN PHYSICAL IMAGES MODAL SHOW STARTS ENDS -------------------------------------------------------->
<div class="overlay" *ngIf="type == 'piezo_powertrain_phy_image'">
  <div class="powertrain-modal">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Powertrain Image</div>
    </div>
    <div class="powertrain-modal-body">
      <img [src]="data.url" [alt]="data.url" class="pt-phy-img" />
    </div>
    <div class="powertrain-modal-footer flex_center_end">
      <button type="button" mat-stroked-button color="primary" (click)="closePTPhysicalimageModalBox()">
        Close
      </button>
      <button type="button" class="btn default_btn" mat-stroked-button color="warn"
        (click)="deletePTPhysicalimageModalBox()">
        Delete
      </button>
    </div>
  </div>
</div>
<!----------------------------------------------------------PIEZO POWERTRAIN POWERTRAIN PHYSICAL IMAGES SHOW  MODAL STARTS ENDS ------------------------------------------->